var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"theme":"light"}},[_c('v-main',{staticStyle:{"height":"100vh"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }